const Colors = {
  bgSubtle: '#f1f3f4', // subtle light gray for background
};
export default Colors;
